const initialState = {
    user: null,
    access_token: null,
    id_token: null,
    apiController: new AbortController()
};

export default function (state = initialState, action) {
    switch (action.type) {
        case "STORE_USER":
            return {
                ...state,
                user: action.payload,
                access_token: action.access_token,
                id_token: action.id_token
            }

        case "STORE_USER_ERROR":
            return {
                user: null,
                apiController: initialState.apiController
            }

        default:
            return state
    }
}